import { CORS } from 'root/utils/cors/cors';

const Lexicon = {
    get: function (filename, callback) {
        var url = '/rest/lexic/GetLexic';
        CORS.xdr(
            url,
            'POST',
            'filename=' + filename,
            function (data) {
                callback(Lexicon.getJSON(data));
            },
            function (err) {
                callback(err);
            }
        );
    },
    getJSON: function (str) {
        var json;
        try {
            json = JSON.parse(str);
        } catch (e) {
            return false;
        }
        return json;
    },
};

export { Lexicon };
